import {Form, Col, FormGroup, Input, Label, Row} from "reactstrap";
import React from "react";

function ContactsCtl(props)
{
	return (
		<Form innerRef={props.formRef}>
			<Input type="hidden" name="contactId" value=""/>
      <Input type="hidden" name="userId" value=""/>
			<Row form>
				<Col md="4">
					<FormGroup>
						<Label for="contactTypeId">Contact Type<span className="required-asterisk">*</span></Label>
						<Input type="select" name="contactTypeId" id="contactTypeId">
							<option value="-1">Select a type</option>
						</Input>
					</FormGroup>
				</Col>
				<Col md="4">
					<FormGroup>
						<Label for="contactFirstName">First Name<span className="required-asterisk">*</span></Label>
						<Input type="text" name="contactFirstName" id="contactFirstName" placeholder="First Name" maxLength="70"/>
					</FormGroup>
				</Col>
				<Col md="4">
					<FormGroup>
						<Label for="contactLastName">Last Name<span className="required-asterisk">*</span></Label>
						<Input type="text" name="contactLastName" id="contactLastName" placeholder="Last Name" maxLength="70"/>
					</FormGroup>
				</Col>
			</Row>
			<Row form>
				<Col md="4">
					<FormGroup>
						<Label for="contactPhone">Phone<span className="required-asterisk">*</span></Label>
						<Input type="tel" name="contactPhone" id="contactPhone" placeholder="Phone Number" maxLength="14"/>
					</FormGroup>
				</Col>
				<Col md="4">
					<FormGroup>
						<Label for="contactMobile">Mobile<span className="required-asterisk">*</span></Label>
						<Input type="tel" name="contactMobile" id="contactMobile" placeholder="Mobile Phone Number" maxLength="14"/>
					</FormGroup>
				</Col>
				<Col md="4">
					<FormGroup>
						<Label for="contactEmail">Email<span className="required-asterisk">*</span></Label>
						<Input type="email" name="contactEmail" id="contactEmail" placeholder="email" maxLength="250"/>
					</FormGroup>
				</Col>
			</Row>
		</Form>);
}

export default ContactsCtl;